import { z } from 'zod';

export const UserUpdateManageSchema = z.object({
    userName: z
        .string({ message: 'main.superAdmin.users.form.userName.error' })
        .email({ message: 'main.superAdmin.users.form.userName.error' }),
    lockoutEnabled: z.boolean().optional(),
    emailConfirmed: z.boolean().optional(),
    isSuperAdmin: z.boolean().optional(),
    tenantRoles: z
        .array(
            z.object({
                tenantId: z.string(),
                roleId: z.string(),
            }),
        )
        .optional(),
});

export const UserCreateManageSchema = UserUpdateManageSchema.omit({
    emailConfirmed: true,
}).extend({
    password: z
        .string({ message: 'main.superAdmin.users.form.password.error' })
        .min(8, { message: 'main.superAdmin.users.form.password.errorRules' }),
});

export type UserUpdateFormData = z.infer<typeof UserUpdateManageSchema>;
export type UserCreateFormData = z.infer<typeof UserCreateManageSchema>;
